import {defineStore} from 'pinia'
import store from "store";

const useProjectStore = defineStore('project', {
    state: () => ({
        info: store.get('project') || {
            projectId: null,
            projectName: null,
            onlyOne: false,
            loaded: false,
        },
    }),
    getters: {
        isOnlyOne(state) {
            return state.info.onlyOne;
        },
        isLoaded() {
            return this.info.loaded;
        },
        projectInfo() {
            return this.info;
        }
    },
    actions: {
        project(project, onlyOne) {
            this.info.loaded = true;
            this.info.projectId = project.projectId;
            this.info.projectName = project.projectName;
            this.info.onlyOne = onlyOne;
            store.set('project', this.info)
            console.log("store project")
            console.log(store.get('project'))
        },
        clear() {
            this.info.loaded = false;
            this.info.projectId = null;
            this.info.projectName = null;
            this.info.onlyOne = false;
            store.remove('project');
        },
    },
})

export default useProjectStore;